var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _polygon, _circle, _path17, _path18, _path19, _path20, _polygon2, _path21, _path22, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path23, _path24, _polygon3, _path25, _path26, _path27, _path28, _path29, _circle2, _path30, _circle3, _path31, _path32, _path33, _path34, _path35, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a90b5256-b423-42d1-825d-5fdc0dc55c5f",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 882.95113,
    height: 612.14792,
    viewBox: "0 0 882.95113 612.14792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M261.42052,674.2439s-112.306-51.70032-72.853-87.55226S261.42052,674.2439,261.42052,674.2439Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M259.46579,686.30766s-51.62-169.60649,24.39238-161.49519S259.46579,686.30766,259.46579,686.30766Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M221.82911,671.26562l2.16658,28.37158.03437.49006a130.3557,130.3557,0,0,0,.67062,13.26586c2.94032,28.939,15.57858,42.12751,30.349,42.12751s26.85843-13.18851,29.79874-42.12751a130.35277,130.35277,0,0,0,.67063-13.26586l.01721-.3955.00856-.09456L287.72,671.26562Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M285.54481,699.6372l-.00856.09456-.01721.3955a130.35277,130.35277,0,0,1-.67063,13.26586H224.70068a130.3557,130.3557,0,0,1-.67062-13.26586l-.03437-.49006Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M993.90848,691.59489s-86.94909-40.0272-56.40393-67.78435S993.90848,691.59489,993.90848,691.59489Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M992.3951,700.93485s-39.965-131.312,18.885-125.03214S992.3951,700.93485,992.3951,700.93485Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M963.25619,689.28906l1.67739,21.96573.02661.37942a100.92376,100.92376,0,0,0,.51921,10.27064c2.27644,22.405,12.06118,32.61578,23.49667,32.61578s20.79422-10.21075,23.07066-32.61578a100.92088,100.92088,0,0,0,.51921-10.27064l.01333-.30621.00662-.07321,1.68406-21.96573Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#e6e6e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.58589,711.25479l-.00662.07321-.01333.30621a100.92088,100.92088,0,0,1-.51921,10.27064H965.4794a100.92376,100.92376,0,0,1-.51921-10.27064l-.02661-.37942Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M451.24048,326.513V287.926h-6v38.587a8,8,0,1,0,6,0Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#e6e6e6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M465.24048,715.926h-41v-498h-16v498H367.24042A36.99993,36.99993,0,0,0,330.24048,752.926v.00006h172V752.926A36.99994,36.99994,0,0,0,465.24048,715.926Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#e6e6e6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M330.32349,291.926h171.834L491.64966,160.58571A18.19785,18.19785,0,0,0,473.60377,143.926H358.8772a18.19786,18.19786,0,0,0-18.0459,16.65967Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#38a7ba"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M569.57951,522.44575h0a12.36991,12.36991,0,0,0-14.25813,10.33891l-4.83778,31.74861,16.46027,4.36571,12.0607-29.58071A12.3699,12.3699,0,0,0,569.57951,522.44575Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#a0616a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M569.27177,564.474c9.13486,36.3022,5.20345,69.506-28.81235,95.5764-40.79944-11.24669-67.9348-38.38169-84.491-77.81795a19.68394,19.68394,0,0,1,11.35278-26.09236h0a19.67385,19.67385,0,0,1,21.65853,5.5824l40.03145,46.20366,18.7797-46.589Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#38a7ba"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M778.31245,754.93293c-37.2533-1.97882-60.39536-14.77032-66-41l6-11L787.007,734.22711a9.60873,9.60873,0,0,1-.67559,17.76554Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#e6e6e6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M749.52715,755.19556c-19.35606-.58621-37.97042-.404-55.60848.78963a11.78112,11.78112,0,0,1-12.54729-10.81562l-1.05893-13.23664-15-24,13-13c21.847,21.75885,45.80661,40.03546,74.26312,50.89948A5.13183,5.13183,0,0,1,749.52715,755.19556Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#e6e6e6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M644.31245,660.93293c-24.71649,44.22607-49.02521,74.04016-81,90-39.33911,12.98389-68.09036-4.21814-90.5-39.5l65-43,9.5,9.5,86.09793-65.51825a10.99335,10.99335,0,0,1,15.46383.34379l73.43824,90.17446-9,15Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#2f2e41"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "507.788 569.007 473.788 517.007 481.788 502.007 526.788 549.007 507.788 569.007",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 311.78801,
    cy: 369.00689,
    r: 34,
    fill: "#a0616a"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M479.31245,575.93293l-38-13a47.19464,47.19464,0,0,0,7-30h31C477.54951,548.19068,477.28526,562.66254,479.31245,575.93293Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#a0616a"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M560.31245,666.93293c-5.697,2.339-6.11334,9.92273-11.5,12.5-26.03951,12.45872-53.589,22.56787-72.5,40.5-44.193-30.01013-85.15469-123.2175-32-164,18.1438,10.6171,34.35086,18.2149,34,0Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#38a7ba"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M537.31245,626.93293l-18.5-6.5-36.5,28.5-16.362-58.90314c-1.13483-4.08539-2.97351-2.01458-5.61389.82325a19.66444,19.66444,0,0,0-33.0025,13.55651c-1.94635,42.72632,10.93823,78.8736,42.97839,106.52338,41.90735-8.9729,59.69214-37.28638,67-74l-1.981-1.32068Q536.4264,631.35642,537.31245,626.93293Z",
    transform: "translate(-158.52443 -143.92604)",
    opacity: 0.2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M474.88749,468.20678c11.21515,2.56229,23.97993,6.19279,24.69571,9.56721,11.53674,2.90712,20.24455,9.87066,22.02258,20.48674a6.35789,6.35789,0,0,1-6.37842,7.37318c-6.274-.08081-15.69249-.68171-21.91184-3.27933-18.0668,11.64106-21.09937,41.91836-13.20939,62.52755l-12.41583-1.13807-12.84495-37.60217L451.56447,562.266l-28.33278-3.74615,3.64939-46.06468a68.6313,68.6313,0,0,1,10.778-30.433,25.91975,25.91975,0,0,1,2.02788-2.62722A36.01052,36.01052,0,0,1,474.88749,468.20678Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "380.285 438.428 411.402 475.011 458.078 419.925 426.54 381.659 380.285 438.428",
    fill: "#3f3d56"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M608.61263,565.11278,571.6083,534.8365c2.10253-5.046,12.19462-3.364,12.19462-3.364l28.96639,29.36594a15.85058,15.85058,0,0,1,2.57139,3.43337h0Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#f2f2f2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M610.29465,563.01027,568.24426,530.211l-46.67593,70.64465L565.511,630.50114c4.20506,1.682,8.41008-1.26151,8.41008-1.26151L616.81246,563.641Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 586.40568,
    y: 533.8238,
    width: 0.68148,
    height: 33.14262,
    transform: "translate(-361.13634 561.77383) rotate(-54.2997)",
    fill: "#38a7ba"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 551.36802,
    y: 593.57656,
    width: 64.02865,
    height: 0.68152,
    transform: "translate(-392.33984 608.92707) rotate(-56.51868)",
    fill: "#38a7ba"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 546.87827,
    y: 594.04279,
    width: 0.68169,
    height: 35.49187,
    transform: "translate(-428.38446 546.06674) rotate(-53.65594)",
    fill: "#38a7ba"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 518.35232,
    y: 567.50542,
    width: 64.0408,
    height: 0.68129,
    transform: "translate(-388.62773 551.26391) rotate(-55.16206)",
    fill: "#38a7ba"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 595.97033,
    y: 523.89768,
    width: 0.42026,
    height: 45.16385,
    transform: "translate(-368.0795 472.27708) rotate(-47.45516)",
    fill: "#b3b3b3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 593.95199,
    y: 523.63114,
    width: 0.42069,
    height: 46.38865,
    transform: "translate(-367.5248 486.42576) rotate(-48.56153)",
    fill: "#b3b3b3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 592.44345,
    y: 523.63791,
    width: 0.42073,
    height: 46.99749,
    transform: "translate(-365.61348 508.13161) rotate(-50.18727)",
    fill: "#b3b3b3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M555.60592,593.0936h0a12.3699,12.3699,0,0,0-17.31358,3.22913l-17.97987,26.61021,13,11,23.57629-21.55546A12.36992,12.36992,0,0,0,555.60592,593.0936Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#a0616a"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M537.31245,630.93293c-7.30789,36.71362-25.09265,65.0271-67,74-32.04018-27.64977-44.92473-63.797-42.97837-106.52334A19.68394,19.68394,0,0,1,448.7755,579.7023h0a19.67386,19.67386,0,0,1,17.17493,14.32748l16.362,58.90315,36.9373-34.0418Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#38a7ba"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "882.556 612.148 0 612.148 0 609.966 882.951 609.966 882.556 612.148",
    fill: "#3f3d56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M619.81245,235.43293a2.002,2.002,0,0,0-2,2v156a2.002,2.002,0,0,0,2,2h130a2.00229,2.00229,0,0,0,2-2v-156a2.00229,2.00229,0,0,0-2-2Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#e6e6e6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M633.31245,379.93293h103v-129h-103Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M836.24528,276.43293a1.19539,1.19539,0,0,0-1.194,1.194V355.2389a1.19539,1.19539,0,0,0,1.194,1.194h93.13433a1.1954,1.1954,0,0,0,1.194-1.194V277.627a1.1954,1.1954,0,0,0-1.194-1.194Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#e6e6e6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M844.305,285.68666V347.1792h77.01492V285.68666Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M702.999,246.43293h-36.373a4.98866,4.98866,0,0,1-4.33008-7.5l18.18652-31.5c.01465-.02588.03027-.05176.04541-.07764a4.94072,4.94072,0,0,1,3.78662-2.39843l.02637-.00245c.15527-.01416.313-.02148.47168-.02148a4.949,4.949,0,0,1,4.33008,2.5l18.18652,31.5a5.00025,5.00025,0,0,1-4.33008,7.5ZM665.622,241.42805a1.02812,1.02812,0,0,0,.13769.50488.983.983,0,0,0,.86622.5h36.373a.98225.98225,0,0,0,.86621-.5,1.02749,1.02749,0,0,0,.1377-.50439.985.985,0,0,0-.1377-.49512l-18.18652-31.50049a1.00032,1.00032,0,0,0-1.73242,0l-18.18653,31.5A.98133.98133,0,0,0,665.622,241.42805Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#e6e6e6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 526.28801,
    cy: 67.50689,
    r: 3,
    fill: "#e6e6e6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M892.6725,278.93293H872.95217a2.7047,2.7047,0,0,1-2.34763-4.06626l9.86016-17.07832.02462-.04209a2.67875,2.67875,0,0,1,2.053-1.30036l.0143-.00132c.08418-.00768.16969-.01165.25573-.01165a2.68319,2.68319,0,0,1,2.34763,1.35542l9.86016,17.07832a2.711,2.711,0,0,1-2.34763,4.06626Zm-20.26461-2.71349a.55736.55736,0,0,0,.07465.27373.53294.53294,0,0,0,.46963.27109H892.6725a.53255.53255,0,0,0,.46963-.27109.55707.55707,0,0,0,.07466-.27347.534.534,0,0,0-.07466-.26843L883.282,258.87269a.54234.54234,0,0,0-.93927,0L872.48254,275.951A.532.532,0,0,0,872.40789,276.21944Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#e6e6e6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 724.2879,
    cy: 116.03099,
    r: 1.62651,
    fill: "#e6e6e6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M634.49062,330.8139a26.49038,26.49038,0,0,1,15.26208-14.32731,26.1812,26.1812,0,0,1,21.81176,1.35712c7.80387,4.1417,14.0425,10.65305,21.96763,14.61673a56.17868,56.17868,0,0,0,24.78608,5.839,55.4781,55.4781,0,0,0,27.7934-7.2142,1.50112,1.50112,0,0,0-1.51416-2.59042,53.34339,53.34339,0,0,1-50.43027.92525c-7.951-4.169-14.25106-10.90053-22.35074-14.80678a28.87992,28.87992,0,0,0-22.23054-1.24775,29.84552,29.84552,0,0,0-17.98808,16.65087c-.728,1.787,2.1729,2.56474,2.89284.79752Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#e6e6e6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M632.12039,358.85656a114.2042,114.2042,0,0,1,50.54024.17516c14.76636,3.42442,30.00938,9.585,45.23381,4.99041,6.80178-2.05269,13.03535-6.15841,16.52959-12.4769.935-1.69082-1.65488-3.20586-2.59042-1.51416-6.5792,11.89691-21.99243,13.9042-34.16617,11.95216-8.13433-1.30432-15.97376-3.91967-23.9804-5.79125a116.87741,116.87741,0,0,0-52.36417-.22826c-1.88344.42053-1.08636,3.31347.79752,2.89284Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#e6e6e6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M631.03928,291.798a118.62787,118.62787,0,0,1,48.04227,1.70916c14.69483,3.6004,29.05874,11.82591,44.597,10.40532,7.1936-.65768,14.31559-3.30335,19.20257-8.80668,1.2781-1.43928-.8362-3.56851-2.12132-2.12132-4.21578,4.74747-10.28784,7.208-16.51871,7.87279-7.18164.76619-14.23808-.72176-21.0736-2.83584-7.56638-2.34012-14.91657-5.3046-22.60926-7.23882a121.4994,121.4994,0,0,0-50.31646-1.87744c-1.89919.3243-1.09393,3.21582.79751,2.89283Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#e6e6e6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M857.71647,284.67353a52.29994,52.29994,0,0,1,13.72209,25.58689,51.6547,51.6547,0,0,1-11.16774,43.86118c-1.243,1.46343.86917,3.59557,2.12132,2.12132a55.41416,55.41416,0,0,0,12.69854-28.67315,54.6929,54.6929,0,0,0-15.25289-45.01756c-1.3539-1.38082-3.47467.74106-2.12132,2.12132Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#e6e6e6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M902.727,278.2718c-9.19406,6.74316-14.34111,17.62729-15.06541,28.88508-.75361,11.7135,3.71362,23.02594,10.90747,32.12048a62.46258,62.46258,0,0,0,14.8484,13.40375c1.62026,1.06015,3.12514-1.53634,1.51415-2.59041-9.18459-6.00953-17.04368-14.54628-21.21739-24.7909a40.11715,40.11715,0,0,1-.08682-30.73794,32.84189,32.84189,0,0,1,10.61376-13.69965c1.54083-1.13008.04586-3.73456-1.51416-2.59041Z",
    transform: "translate(-158.52443 -143.92604)",
    fill: "#e6e6e6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 533.28801,
    cy: 150.50689,
    r: 14,
    fill: "#e6e6e6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg6);
export default __webpack_public_path__ + "static/media/svg-6.7de5022c507c0bfe18ef38049e74fa05.svg";
export { ForwardRef as ReactComponent };